import {
  API_JWT_ACCESS_URL,
  API_JWT_VERIFY_URL,
  API_SSO_USER_URL,
  API_FORGOT_PASSWORD_URL,
  API_RESET_PASSWORD_URL,
  API_COUNTRY_URL,
  API_BRANCH_URL,
  API_DEPARTMENT_URL,
  API_JOBTITLE_URL,
  API_SALARY_URL,
  API_SALARY_CAL_URL,
  API_POST_PAYROLL_TRANSACTION_URL,
  API_PAYROLL_TRANSACTION_URL,
  API_PAYROLL_MONTHLY_SUMMARY_URL,
  API_ETHNICITY_URL,
  API_WORK_PASS_TYPE_URL,
  API_RESIDENTIAL_STATUS_URL,
  API_CPF_RATE_URL,
  API_SHG_RATE_URL,
  API_SDL_RATE_URL,
  API_EMPLOYEE_URL,
  API_POSTJOBDETAIL_URL,
  API_EMERGENCY_CONTACTS_URL,
  API_LEAVE_TYPE_URL,
  API_LEAVE_HOLIDAY_URL,
  API_LEAVE_POLICY_URL,
  API_LEAVE_BALANCE_URL,
  API_LEAVE_REQUEST_URL,
  API_LEAVE_REQUEST_CALCULATE_URL,
  API_USER_URL,
  API_ALL_USER_URL,
  API_SSO_ALL_USER_URL,
  API_UPDATE_USER_URL,
  API_USER_GROUP_URL,
  API_CREATE_USER_URL,
  API_SERVICE_URL,
  API_CONNECTION_URL,
  API_ORGANIZATION_HRM_URL,
  API_AUDIT_LOG_URL,
  API_AUDIT_CONFIG_URL,
  API_LOGOUT_URL,
} from './config.js';
import { AJAX } from './helpers.js';
import { AJAXFILE } from './helpers.js';

//Initialize the required object data and group them under state object
export const state = {
  search: {
    query: '',
    results: [],
    chartresults: [],
    cameraresults: [],
    camerastate: [],
  },
  employee: {
    matchResults: [],
    results: [],
    editDbResults: [],
    uploadedResult: [],
    originalResults: [],
  },
  jobdetail: {
    editDbResults: [],
  },
  salary: {
    editDbResults: [],
    results: [],
  },
  emergencycontact: {
    editDbResults: [],
  },
  department: {
    results: [],
    editDbResults: [],
  },
  jobtitle: {
    results: [],
    editDbResults: [],
    matchResults: [],
    oldResults: [],
  },
  ethnicity: {
    results: [],
    editDbResults: [],
  },
  workpasstype: {
    results: [],
    editDbResults: [],
  },
  residentialstatus: {
    results: [],
    editDbResults: [],
  },
  rate: {
    cpfResults: [],
    shgResults: [],
    sdlResults: [],
    sdlEditResults: [],
    shgEditResults: [],
    cpfEditResults: [],
  },
  payroll: {
    results: [],
    summaryResults: [],
  },
  leave: {
    leaveTypeResults: [],
    leaveHolidayResults: [],
    leavePolicyResults: [],
    leaveBalanceResults: [],
    leaveBalanceEmployeeResults: [],
    leaveRequestResults: [],
    leaveRequestEmployeeResults: [],
    leaveRequestMyEmployeeResults: [],
    // leaveRequestActiveTab: 'leave-request-datatab-employee', // used by leaveRequestView.js directly
    leaveTypeEditResults: [],
    leaveHolidayEditResults: [],
    leavePolicyEditResults: [],
    leaveBalanceEditResults: [],
  },
  user: {
    results: [],
    ssoResults: [],
    allResult: [],
    allMatchResults: [],
    editDbResults: [],
    connection: [],
    groupResults: [],
    group: [],
    editgroup: [],
    editDbResultsSSO: [],
    country: [],
  },
  chart: {
    monthlySales: [],
    sortedMonthlySales: [],
    monthlySalesData: {},
    customerSales: [],
    customerSalesData: [],
    monthlyBill: [],
    sortedMonthlyBill: [],
    monthlyBillData: {},
  },
  branch: {
    results: [],
    resultsDropDown: [],
  },
  service: {
    results: [],
    cmsResult: [],
  },
  organization: {
    hrmResults: [],
  },
  audit: {
    logResults: [],
    configResults: [],
    configEditResults: [],
  },
};

/* FUNCTIONS */

// To generate unique Order Number. Can be used for other unique Number as well.
const addUniqueNumber = function () {
  const stringId = Date.now().toString();
  const randomId = Math.floor(Math.random() * 100);
  const dualDigits = randomId > 9 ? randomId.toString() : '0' + randomId; // add a "0" prefix if it is a single digit
  return stringId + dualDigits;
};

const titleCase = function (string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase();
};

/* ACCESS */

// To retrieve the JWT access and refresh token and save it in Local Storage
const loadToken = async function (loginDetails) {
  try {
    const method = 'POST';
    const data = await AJAX(
      `${API_JWT_ACCESS_URL}`,
      null,
      loginDetails,
      method,
    );
    localStorage.setItem('accesstoken', data.access);
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// // To verify token validity
// const verifyToken = async function (token, tokenJson) {
//   try {
//     const method = 'POST';
//     const data = await AJAX(`${API_JWT_VERIFY_URL}`, token, tokenJson, method);
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

//Manage login with ID and password
export const login = async function (newLogin) {
  try {
    //convert to API package format
    const loginDetails = {
      email: newLogin.loginid,
      password: newLogin.loginpassword,
    };
    //GET access token
    await loadToken(loginDetails);
    const token = localStorage.getItem('accesstoken');
    if (token !== null) {
      window.location.href = './main.html';
      localStorage.setItem('username', JSON.stringify(newLogin.loginid));
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//Manage login with ID and password
export const forgotPassword = async function (user) {
  try {
    //convert to API package format
    const loginEmail = {
      email: user.loginid,
    };
    //Check validity of email and trigger reset password email via API call
    // const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_FORGOT_PASSWORD_URL}`,
      null,
      loginEmail,
      method,
    );
  } catch (err) {
    console.error(err.message);
    throw err;
  }
};

//Check login status. Log out if token is not valid or verified
export const isLoggedin = async function () {
  try {
    const token = localStorage.getItem('accesstoken');
    // no access token at all
    if (!token || token === 'undefined' || token === 'null') {
      localStorage.removeItem('accesstoken');
      localStorage.removeItem('username');
      window.location.href = './index.html';
      return;
    }
  } catch (err) {
    console.error(err);
    logout(); //redirect to login page and remove the expired access token. To troubleshoot immediate logout after login, blanko this line!
  }
};

//Control loading of standard menu based on user profile
export const loadMenu = async function () {
  try {
    // Load user and organization details to landing page
    await loadSSOUserSearchResults();
    await loadUserResults();
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//Log out user
export const logout = async function () {
  try {
    await AJAX(API_LOGOUT_URL, null, null, 'POST');
    // Remove the token and redirect to login page
    localStorage.removeItem('accesstoken');
    localStorage.removeItem('username');
    window.location.href = './index.html';
  } catch (err) {
    console.error(err);
    throw err;
  }
};

/* LOAD SEARCH RESULTS*/

// To retrieve the country list from django.countries
export const loadCountrySearchResults = async function () {
  try {
    const query = '#';
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');
    //GET country list from Django django_countries package
    const data = await AJAX(`${API_COUNTRY_URL}?search=${query}`, token);

    state.user.country = data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To retrieve the login user and organization details from local domain. This is needed as logo image cannot be retrieved cross domain by jsPdf > html2canvas (for document)
// Note that this will only retrieve the one record which is the login user (owner) record.
//This is only used in entire program to retrieve the login user org logo, user group (for menu) . All other user info are retrieved from SSO.
export const loadUserResults = async function (query) {
  try {
    const searchQuery = '#';
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_USER_URL}?search=${searchQuery}`, token);
    // console.log(data);

    // To retrieve the logo from the org, if null get from the parent org
    const orgLogo =
      data.organization.logo === null && data.organization.parent_org
        ? data.organization.parent_org_logo
        : data.organization.logo;

    const orgId = data.organization ? data.organization.id : null;
    //Filter not needed
    // ✅ Filter out user groups that do not start with "HR" (case-insensitive) by coverting to Array first
    // Only HR related groups are used
    // const filteredGroups = Array.isArray(data.groups)
    //   ? data.groups.filter(grp => grp.name?.toLowerCase().startsWith('hr'))
    //   : [];
    const filteredGroups = data.groups;

    // ✅ Store both the filtered groups and the names
    state.user.results = {
      ...data,
      orgLogo,
      orgId,
      groups: filteredGroups, // replaces original groups with filtered ones
      groupName: filteredGroups.map(grp => grp.name),
    };
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To retrieve the login user and organization details from sso domain. Note that this will only retrieve the one record which is the login user (owner) record.
//!! LOGIN USER MUST HAVE AN ORGANIZATION LINKED TO IT IN SSO, ELSE ORG RELATED DATA CANNOT BE RETRIEVED AND IT WILL IMMEDIATELY LOGOUT
export const loadSSOUserSearchResults = async function (query) {
  try {
    // state.search.query = query;
    const query = '#';
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');
    //GET user API using search query and access token. Note that this API will only return one owner result due to settings set in Django
    const data = await AJAX(`${API_SSO_USER_URL}?search=${query}`, token);

    //To form the user name initial to be populated to the nav bar
    const initial =
      data.first_name.slice(0, 1).toUpperCase() +
      data.last_name.slice(0, 1).toUpperCase();

    // To retrieve the logo from the org, if null get from the parent org
    const orgLogo =
      data.organization.logo === null && data.organization.parent_org
        ? data.organization.parent_org.logo
        : data.organization.logo;
    // To retrieve the registration id from the org, if null get from the parent org
    const orgRegID =
      data.organization.registration_id === null && data.organization.parent_org
        ? data.organization.parent_org.registration_id
        : data.organization.registration_id;

    // To retrieve the tax value from the org, if null get from the parent org
    const orgTaxID =
      data.organization.tax_id === null && data.organization.parent_org
        ? data.organization.parent_org.tax_id
        : data.organization.tax_id;

    // To retrieve the parent org, if null set to null
    const parentOrgId = data.organization.parent_org
      ? data.organization.parent_org.id
      : null;

    // To retrieve the tax value from the org, if null get from the parent org
    const orgTaxValue =
      data.organization.tax_value === null && data.organization.parent_org
        ? data.organization.parent_org.tax_value
        : data.organization.tax_value;

    const orgId = data.organization ? data.organization.id : null;

    const userBranch = data.organization ? data.organization.branch_name : null;

    state.user.ssoResults = data; // data.map is not needed as only one result will be returned and it returns as an Object instead of Array of Objects.
    state.user.ssoResults.initial = initial;
    state.user.ssoResults.orgLogo = orgLogo;
    state.user.ssoResults.orgRegID = orgRegID;
    state.user.ssoResults.orgTaxID = orgTaxID;
    state.user.ssoResults.orgTaxValue = orgTaxValue;
    state.user.ssoResults.orgId = orgId;
    state.user.ssoResults.parentOrgId = parentOrgId;
    state.user.ssoResults.userBranch = userBranch;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To load the all user search results + user field autocomplete
export const loadUserSearchResults = async function (query, selectedQuery) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token. If selectQuery (from UserMatchList) is not undefined, search only based on selectedQuery which gives better performance
    const data =
      selectedQuery === undefined
        ? await AJAX(`${API_ALL_USER_URL}?search=${query}`, token)
        : await AJAX(`${API_ALL_USER_URL}?search=${selectedQuery}`, token);
    // if selectedQuery is not null, execute the RegExp else set the array to []

    state.user.allMatchResults = !selectedQuery
      ? []
      : data
          .filter(user => {
            const regex = new RegExp(`^${selectedQuery}`, 'gi'); //use RegExp to match the startwith of query and gi to ignore case
            return user.email.match(regex); // return user nick name
          })
          .map(user => {
            return {
              id: user.id,
              userEmail: user.email,
              matchlistName: user.email,
            };
          });

    //Call the function to convert the Objects format to populate to tables
    state.user.allResult = data.map(user => {
      // const userBranch =
      //   user.organization === null ? null : user.organization.branch_name; // retrieve the branch of the user
      // const userActive = user.is_active ? 'Y' : 'N'; // change user is_active from true/false to Y/N
      // const createdDate = user.created_at.toLocaleString().slice(0, 10);
      // // const lastLoginDate = user.last_login.toLocaleString().slice(0, 10);
      // // ✅ Filter out any groups that does not start with "HR"
      // const filteredGroups = (user.groups || []).filter(grp =>
      //   grp.name?.toUpperCase().startsWith('HR')
      // );

      // // ✅ Extract all remaining group names as comma-separated string
      // const userGroupNames =
      //   filteredGroups.length > 0
      //     ? filteredGroups.map(grp => grp.name).join(', ')
      //     : null;

      return {
        id: user.id,
        userFirstName: user.first_name,
        userLastName: user.last_name,
        userNickName: user.nick_name,
        userMobile: user.mobile,
        userEmail: user.email,
        // userBranch: userBranch,
        // userGroup: userGroupNames,
        // // userLastLoginDate: lastLoginDate,
        // userCreatedDate: createdDate,
        // userActive: userActive,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the User Groups list
export const loadUserGroupResults = async function (query) {
  try {
    const searchQuery = '#';
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(
      `${API_USER_GROUP_URL}?search=${searchQuery}`,
      token,
    );

    // To remove the option of selecting SuperAdmin if the login user is not SuperAdmin. Do not need to apply this to others as only SuperAdmin and Admin has access to User menu
    const userGroup = state.user.results.groupName || [];
    let groupResults = data;

    // 1️⃣ Filter out HRSuperAdmin if current user is NOT SuperAdmin
    if (!userGroup.includes('HRSuperAdmin')) {
      groupResults = groupResults.filter(grp => grp.name !== 'HRSuperAdmin');
    }

    // 2️⃣ Filter out any group whose name starts with 'HR' (case-insensitive)
    groupResults = groupResults.filter(grp =>
      grp.name?.toUpperCase().startsWith('HR'),
    );

    state.user.groupResults = groupResults.map(grp => {
      return {
        id: grp.id,
        name: grp.name,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to find the id of the cms system, so that it can be used for adding connection to cms when user is added
export const loadServiceResults = async function (query) {
  try {
    const searchQuery = '#';
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_SERVICE_URL}?search=${searchQuery}`, token);
    // console.log(data);

    state.service.results = data.map(svc => {
      return {
        id: svc.id,
        name: svc.name,
        identifier: svc.identifier,
        // url: svc.callback_url,
      };
    });

    // To find the cms service from the array
    state.service.cmsResult = state.service.results.find(
      x => x.identifier === 'cms',
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Organization from CMS
export const loadOrganizationHrmResults = async function (
  query,
  selectedQuery,
) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET Org API using search query and access token
    const data =
      selectedQuery === undefined
        ? await AJAX(`${API_ORGANIZATION_HRM_URL}?search=${query}`, token)
        : await AJAX(
            `${API_ORGANIZATION_HRM_URL}?search=${selectedQuery}`,
            token,
          );
    // if selectedQuery is not null, execute the RegExp else set the array to []
    state.organization.matchResults = !selectedQuery
      ? []
      : data
          .filter(org => {
            const regex = new RegExp(`^${selectedQuery}`, 'gi'); //use RegExp to match the startwith of query and gi to ignore case
            return org.name.match(regex); // return job title name
          })
          .map(org => {
            return {
              orgId: org.id,
              orgName: org.name,
              orgCountry: org.country,
              matchlistName: org.name,
            };
          });

    state.organization.hrmResults = data.map(org => {
      return {
        id: org.id,
        name: org.name,
        branchName: org.branch_name,
        parentOrg: org.parent_org,
        country: org.country,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the User Groups list
export const loadDepartmentResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_DEPARTMENT_URL}?search=${query}`, token);

    state.department.results = data.map(dep => {
      const insertDate = dep.insert_date.toLocaleString().slice(0, 10);
      const updateDate = dep.update_date.toLocaleString().slice(0, 10);
      return {
        id: dep.id,
        departmentName: dep.name,
        departmentDescription: dep.description,
        insertDate: insertDate,
        updateDate: updateDate,
        active: dep.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To retrieve the Branch
export const loadJobTitleSearchResults = async function (query, selectedQuery) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET branch API using search query and access token. If selectedQuery (from BranchMatchList) is not undefined, search only based on selectedQuery which gives better performance
    const data =
      selectedQuery === undefined
        ? await AJAX(`${API_JOBTITLE_URL}?search=${query}`, token)
        : await AJAX(`${API_JOBTITLE_URL}?search=${selectedQuery}`, token);
    // if selectedQuery is not null, execute the RegExp else set the array to []
    state.jobtitle.matchResults = !selectedQuery
      ? []
      : data
          .filter(jt => {
            const regex = new RegExp(`^${selectedQuery}`, 'gi'); //use RegExp to match the startwith of query and gi to ignore case
            return jt.title.match(regex); // return job title name
          })
          .map(jt => {
            return {
              id: jt.id,
              jobTitle: jt.title,
              matchlistName: jt.title,
            };
          });

    state.jobtitle.results = data.map(jt => {
      const insertDate = jt.insert_date.toLocaleString().slice(0, 10);
      const updateDate = jt.update_date.toLocaleString().slice(0, 10);
      return {
        id: jt.id,
        jobTitle: jt.title,
        jobTitleDescription: jt.description,
        jobTitleLevel: jt.level,
        insertDate: insertDate,
        updateDate: updateDate,
        active: jt.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Ethnicity list
export const loadEthnicityResults = async function (query) {
  try {
    // // Find the org Country based on User Organization entry, if it is left blank, default to 'SG'
    // let orgCountry = orgName
    //   ? state.organization.hrmResults.find(org => org.name === orgName).country
    //   : 'SG';

    // // Use GB to contain a common global list for ethnicity. Only US and SG has mandatory reporting required
    // let orgCountryFinal =
    //   orgCountry !== 'SG' && orgCountry !== 'US' ? 'GB' : orgCountry;

    // // To allow SuperAdmin role to see all country records
    // const userRole = state.user.results.groupName;
    // const HRSuperAdminRole =
    //   userRole.includes('StylbotAdmin') || userRole.includes('HRSuperAdmin');
    // if (HRSuperAdminRole) {
    //   orgCountryFinal = ''; //
    // }

    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    // //GET user API with Country Filter using search query and access token
    // const data = await AJAX(
    //   `${API_ETHNICITY_URL}?country=${orgCountryFinal}&search=${query}`,
    //   token,
    // );

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(`${API_ETHNICITY_URL}?search=${query}`, token);

    state.ethnicity.results = data.map(etc => {
      const insertDate = etc.insert_date.toLocaleString().slice(0, 10);
      const updateDate = etc.update_date.toLocaleString().slice(0, 10);
      // const ethnicityCountryName = state.user.country.find(
      //   ctry => ctry.code === etc.country,
      // ).name;
      return {
        id: etc.id,
        ethnicityName: etc.name,
        ethnicityCountry: etc.country,
        insertDate: insertDate,
        updateDate: updateDate,
        active: etc.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadWorkPassTypeResults = async function (query) {
  try {
    // // Find the org Country based on User Organization entry, if it is left blank, default to 'SG'
    // let orgCountry = orgName
    //   ? state.organization.hrmResults.find(org => org.name === orgName).country
    //   : 'SG';

    // // To allow SuperAdmin role to see all country records
    // const userRole = state.user.results.groupName;
    // const HRSuperAdminRole =
    //   userRole.includes('StylbotAdmin') || userRole.includes('HRSuperAdmin');
    // if (HRSuperAdminRole) {
    //   orgCountry = ''; //
    // }

    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(`${API_WORK_PASS_TYPE_URL}?search=${query}`, token);

    state.workpasstype.results = data.map(wp => {
      const insertDate = wp.insert_date.toLocaleString().slice(0, 10);
      const updateDate = wp.update_date.toLocaleString().slice(0, 10);
      // const workPassTypeCountryName = state.user.country.find(
      //   ctry => ctry.code === wp.country,
      // ).name;
      return {
        id: wp.id,
        workPassTypeName: wp.name,
        workPassTypeCountry: wp.country,
        insertDate: insertDate,
        updateDate: updateDate,
        active: wp.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadResidentialStatusResults = async function (query) {
  try {
    // // Find the org Country based on User Organization entry, if it is left blank, default to 'SG'
    // let orgCountry = orgName
    //   ? state.organization.hrmResults.find(org => org.name === orgName).country
    //   : 'SG';

    // // To allow SuperAdmin role to see all country records
    // const userRole = state.user.results.groupName;
    // const HRSuperAdminRole =
    //   userRole.includes('StylbotAdmin') || userRole.includes('HRSuperAdmin');
    // if (HRSuperAdminRole) {
    //   orgCountry = '';
    // }

    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(
      `${API_RESIDENTIAL_STATUS_URL}?search=${query}`,
      token,
    );

    state.residentialstatus.results = data.map(res => {
      const insertDate = res.insert_date.toLocaleString().slice(0, 10);
      const updateDate = res.update_date.toLocaleString().slice(0, 10);
      // const residentialStatusCountryName = state.user.country.find(
      //   ctry => ctry.code === res.country,
      // ).name;
      return {
        id: res.id,
        residentialStatusName: res.name,
        residentialStatusCountry: res.country,
        insertDate: insertDate,
        updateDate: updateDate,
        active: res.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the CPF Rate list
export const loadCpfRateSearchResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_CPF_RATE_URL}?search=${query}`, token);

    state.rate.cpfResults = data.map(cpf => {
      const effectiveDate = cpf.effective_date.toLocaleString().slice(0, 10);

      return {
        id: cpf.id,
        cpfResidentialStatus: cpf.residential_status,
        cpfResidentialStatusName: cpf.residential_status_name,
        cpfMinAge: cpf.age_min,
        cpfMaxAge: cpf.age_max,
        cpfMaxWage: cpf.total_wages_max,
        cpfMinWage: cpf.total_wages_min,
        cpfOWCeiling: cpf.ordinary_wage_ceiling,
        cpfAWCeiling: cpf.additional_wage_ceiling,
        cpfTotalRate: cpf.total_rate,
        cpfEmployeeRate: cpf.employee_rate,
        effectiveDate: effectiveDate,
        active: cpf.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the CPF Rate list
export const loadShgRateSearchResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_SHG_RATE_URL}?search=${query}`, token);

    state.rate.shgResults = data.map(shg => {
      const effectiveDate = shg.effective_date.toLocaleString().slice(0, 10);
      // const expiryDate = shg.expiry_date
      //   ? shg.expiry_date.toLocaleString().slice(0, 10)
      //   : null;

      return {
        id: shg.id,
        shgEthnicity: shg.ehtnicity,
        shgEthnicityName: shg.ethnicity_name,
        shgGroupName: shg.group_name,
        shgMaxWage: shg.wages_max,
        shgMinWage: shg.wages_min,
        shgContributionAmount: shg.contribution_amount,
        effectiveDate: effectiveDate,
        active: shg.active,
        // expiryDate: expiryDate,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the CPF Rate list
export const loadSdlRateSearchResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API using search query and access token
    const data = await AJAX(`${API_SDL_RATE_URL}?search=${query}`, token);

    state.rate.sdlResults = data.map(sdl => {
      const effectiveDate = sdl.effective_date.toLocaleString().slice(0, 10);

      return {
        id: sdl.id,
        sdlMinAmount: sdl.min_amount,
        sdlMaxAmount: sdl.max_amount,
        sdlRate: sdl.rate,
        effectiveDate: effectiveDate,
        active: sdl.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// Function to return primary and secondary objects of emergency contacts from an array
const normalizeEmergencyContacts = function (emergencyContacts) {
  if (!Array.isArray(emergencyContacts) || emergencyContacts.length === 0) {
    return { primaryContact: null, secondaryContact: null };
  }

  const primaryContact =
    emergencyContacts.find(c => c.is_primary === true) || null;
  // Pick secondary as the non-primary with the smallest id
  const secondaryContact =
    emergencyContacts
      .filter(c => !c.is_primary)
      .sort((a, b) => a.id - b.id)[0] || null;

  return { primaryContact, secondaryContact };
};

// To load the customer search results + customer field autocomplete
export const loadEmployeeSearchResults = async function (query, selectedQuery) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET packages API using search query and access token. If selectQuery (from PackageCustomerMatchList) is not undefined, search only based on selectedQuery which gives better performance
    const data =
      selectedQuery === undefined
        ? await AJAX(`${API_EMPLOYEE_URL}?search=${query}`, token)
        : await AJAX(`${API_EMPLOYEE_URL}?search=${selectedQuery}`, token);
    // if selectedQuery is not null, execute the RegExp else set the array to []
    // console.log(data);
    state.employee.matchResults = !selectedQuery
      ? []
      : data
          .filter(pp => {
            const regex = new RegExp(`^${selectedQuery}`, 'gi'); //use RegExp to match the startwith of query and gi to ignore case
            return pp.nick_name.match(regex); // return customer nick name
          })
          .map(pp => {
            return {
              id: pp.employee_id,
              employeeName: pp.nick_name,
              matchlistName: pp.nick_name,
            };
          });

    //Call the function to convert the Objects format to populate to tables
    state.employee.results = data.map(pp => {
      const createdDate = pp.insert_date.toLocaleString().slice(0, 10);
      const joinDate = pp.date_joined.toLocaleString().slice(0, 10);
      const leftDate = pp.date_left
        ? pp.date_left.toLocaleString().slice(0, 10)
        : null;
      const currentJobDetailId =
        pp.latest_job !== null ? pp.latest_job.id : null;
      const currentJobDetailStartDate =
        pp.latest_job !== null ? pp.latest_job.start_date : null;
      const currentJobTitle =
        pp.latest_job !== null ? pp.latest_job.job_title.title : null;
      const currentJobTitleId =
        pp.latest_job !== null ? pp.latest_job.job_title.id : null;
      const currentJobLevel =
        pp.latest_job !== null ? pp.latest_job.job_title.level : null;
      const currentDepartment =
        pp.latest_job !== null ? pp.latest_job.department.name : null;
      const currentDepartmentId =
        pp.latest_job !== null ? pp.latest_job.department.id : null;
      const currentOrgName =
        pp.latest_job !== null ? pp.latest_job.organization_name : null;
      const currentOrgCountry =
        pp.latest_job !== null ? pp.latest_job.organization_country : null;
      const currentOrgId =
        pp.latest_job !== null ? pp.latest_job.organization : null;
      const currentOrgBranch =
        pp.latest_job !== null ? pp.latest_job.organization_branch : null;
      const currentManagerName =
        pp.latest_job !== null ? pp.latest_job.manager_name : null;
      const currentManagerId =
        pp.latest_job !== null ? pp.latest_job.manager : null;
      const currentEmploymentType =
        pp.latest_job !== null ? pp.latest_job.employment_type : null;
      const currentSalaryId =
        pp.latest_salary !== null ? pp.latest_salary.id : null;
      const currentBaseSalary =
        pp.latest_salary !== null ? pp.latest_salary.base_salary : null;
      const currentAnnualWageSupplement =
        pp.latest_salary !== null
          ? pp.latest_salary.annual_wage_supplement
          : null;
      const currentTransportAllowance =
        pp.latest_salary !== null ? pp.latest_salary.allowance_transport : null;
      const currentOtherAllowance =
        pp.latest_salary !== null ? pp.latest_salary.allowance_other : null;
      const currentCharityDeduction =
        pp.latest_salary !== null ? pp.latest_salary.deduction_charity : null;
      const currentOtherDeduction =
        pp.latest_salary !== null ? pp.latest_salary.deduction_other : null;
      const currentComchestDeduction =
        pp.latest_salary !== null ? pp.latest_salary.deduction_comchest : null;
      const currentPayFrequency =
        pp.latest_salary !== null ? pp.latest_salary.pay_frequency : null;
      const currentSalaryEffectiveDate =
        pp.latest_salary !== null
          ? pp.latest_salary.effective_date.toLocaleString().slice(0, 10)
          : null;

      // Normalize emergency contacts
      const { primaryContact, secondaryContact } = normalizeEmergencyContacts(
        pp.emergency_contacts,
      );

      return {
        id: pp.employee_id,
        employeeuuid: pp.employee_uuid,
        employeeMainImage: pp.avatar || '',
        employeeMainImageOffsetX: pp.avatar_offset_x,
        employeeMainImageOffsetY: pp.avatar_offset_y,
        employeeMainImageScale: pp.avatar_scale,
        employeeUserId: pp.user,
        employeeUserEmail: pp.user_email,
        employeeFullName: pp.full_name,
        employeeFirstName: pp.first_name,
        employeeLastName: pp.last_name,
        employeeNickName: pp.nick_name,
        employeeGender: pp.gender,
        employeeAge: pp.age,
        employeeWorkMobile: pp.work_mobile,
        employeeWorkEmail: pp.work_email,
        employeePersonalMobile: pp.personal_mobile,
        employeePersonalEmail: pp.personal_email,
        employeeBirthday: pp.date_of_birth,
        employeeEthnicity: pp.ethnicity_name,
        employeeCitizenshipName: pp.citizenship_country,
        employeeCitizenship: pp.citizenship,
        employeeResidentialStatusName: pp.residential_status_name,
        employeeResidentialStatus: pp.residential_status,
        employeeMaritalStatus: pp.marital_status,
        employeeAddress: pp.address,
        employeeUnitNo: pp.unit_no,
        employeeCountry: pp.country,
        employeePostcode: pp.postcode,
        employeeNationalID: pp.national_id,
        employeeFinNo: pp.fin_no,
        employeeWorkPassTypeName: pp.work_pass_type_name,
        employeeWorkPassNo: pp.work_pass_no,
        employeeCurrentJobDetailId: currentJobDetailId,
        employeeCurrentJobDetailStartDate: currentJobDetailStartDate,
        employeeCurrentJobTitle: currentJobTitle,
        employeeCurrentDepartment: currentDepartment,
        employeeCurrentOrgName: currentOrgName,
        employeeCurrentOrgCountry: currentOrgCountry,
        employeeCurrentOrgBranch: currentOrgBranch,
        employeeCurrentManagerName: currentManagerName,
        employeeCurrentJobTitleId: currentJobTitleId,
        employeeCurrentDepartmentId: currentDepartmentId,
        employeeCurrentOrgId: currentOrgId,
        employeeCurrentManagerId: currentManagerId,
        employeeCurrentEmploymentType: currentEmploymentType,
        employeeCurrentJobLevel: currentJobLevel,
        employeeCurrentSalaryId: currentSalaryId,
        employeeCurrentBaseSalary: currentBaseSalary,
        employeeCurrentAnnualWageSupplement: currentAnnualWageSupplement,
        employeeCurrentTransportAllowance: currentTransportAllowance,
        employeeCurrentOtherAllowance: currentOtherAllowance,
        employeeCurrentCharityDeduction: currentCharityDeduction,
        employeeCurrentOtherDeduction: currentOtherDeduction,
        employeeCurrentComchestDeduction: currentComchestDeduction,
        employeeCurrentPayFrequency: currentPayFrequency,
        employeeCurrentSalaryEffectiveDate: currentSalaryEffectiveDate,
        employeeActive: pp.active,
        employeeInsertDate: createdDate,
        employeeJoinDate: joinDate,
        employeeLeftDate: leftDate,
        // Add normalized contacts. Need to list out the fields so that if there is e.g no secondary contact, it will not appear as "undefined" in each field
        employeePrimaryContact: primaryContact || {
          id: null,
          name: '',
          relationship: '',
          address: '',
          mobile: '',
          email: '',
        },
        employeeSecondaryContact: secondaryContact || {
          id: null,
          name: '',
          relationship: '',
          address: '',
          mobile: '',
          email: '',
        },
        permissions: pp.permissions || {},
        editableFields: pp.permissions?.editable_fields || [],
        isHR: pp.permissions?.is_hr || false,
      };
    });

    // console.log(state.employee.results);

    // Store the original employee results before inline edit.
    // This is needed because inline edit will mutate the values in state.employee.results so that the original value is lost
    const apiResults = state.employee.results;

    // Store the immutable snapshot for comparisons later
    state.employee.originalResults = JSON.parse(JSON.stringify(apiResults));
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To get Salary via API call
export const loadCalcSalaryResults = async function (query) {
  try {
    //GET salary via API call
    const token = localStorage.getItem('accesstoken');
    const data = await AJAX(
      `${API_SALARY_CAL_URL}?employee_uuids=${query}`,
      token,
    );

    state.salary.results = data.map(pp => {
      return {
        salaryId: pp.id,
        employeeId: pp.employee,
        employeeWorkEmail: pp.work_email,
        employeeResidentialStatusId: pp.residential_status_id,
        employeeResidentialStatusName: pp.residential_status_name,
        employeeFirstName: pp.first_name,
        employeeLastName: pp.last_name,
        employeeCurrentBaseSalary: pp.base_salary,
        employeeCurrentAnnualWageSupplement: pp.annual_wage_supplement,
        employeeCurrentTransportAllowance: pp.allowance_transport,
        employeeCurrentOtherAllowance: pp.allowance_other,
        employeeCurrentCharityDeduction: pp.deduction_charity,
        employeeCurrentOtherDeduction: pp.deduction_other,
        employeeCurrentComchestDeduction: pp.deduction_comchest,
        employeeCurrentCommission: pp.commission,
        employeeCurrentVariableBonus: pp.variable_bonus,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadPayrollSearchResults = async function (query) {
  try {
    // Find the org Country based on User Organization entry, if it is left blank, default to 'SG'

    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(
      `${API_PAYROLL_TRANSACTION_URL}?search=${query}`,
      token,
    );

    state.payroll.results = data.map(pay => {
      return {
        id: pay.id,
        uuid: pay.payroll_uuid,
        employeeId: pay.employee,
        employeeLastName: pay.last_name,
        employeeFirstName: pay.first_name,
        employeeEmail: pay.work_email,
        period: pay.period,
        baseSalary: pay.base_salary,
        commission: pay.commission,
        allowanceTransport: pay.allowance_transport,
        allowanceOther: pay.allowance_other,
        claims: pay.claims,
        annualWageSupplement: pay.annual_wage_supplement,
        variableBonus: pay.variable_bonus,
        ordinaryWages: pay.ordinary_wages,
        additionalWages: pay.additional_wages,
        owSubjectToCpf: pay.ow_subject_to_cpf,
        awSubjectToCpf: pay.aw_subject_to_cpf,
        cpfEmployeeRate: pay.cpf_employee_rate,
        cpfEmployerRate: pay.cpf_employer_rate,
        cpfTotalRate: pay.cpf_total_rate,
        owCeiling: pay.ow_ceiling,
        awCeilingAnnual: pay.aw_ceiling_annual,
        cpfEmployee: pay.cpf_employee,
        cpfEmployer: pay.cpf_employer,
        cpfTotal: pay.cpf_total,
        sdlRate: pay.sdl_rate,
        sdlAmount: pay.sdl_amount,
        shgGroup: pay.shg_group,
        shgContribution: pay.shg_contribution,
        totalSalary: pay.total_salary,
        deductionCharity: pay.deduction_charity,
        deductionOther: pay.deduction_other,
        deductionComchest: pay.deduction_comchest,
        totalDeductions: pay.total_deductions,
        netPay: pay.net_pay,
        awYtdBefore: pay.aw_ytd_before,
        awUsedThisMonth: pay.aw_used_this_month,
        awRemainingCeilingYtd: pay.aw_remaining_ceiling_ytd,
        awRemainingCeilingAfter: pay.aw_remaining_ceiling_after,
        ytdOw: pay.ytd_ow,
        ytdAw: pay.ytd_aw,
        ytdCpfEmployee: pay.ytd_cpf_employee,
        ytdCpfEmployer: pay.ytd_cpf_employer,
        createdAt: pay.created_at,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Payroll monthly Summary
export const loadPayrollMonthlySummarySearchResults = async function (query) {
  try {
    // Find the org Country based on User Organization entry, if it is left blank, default to 'SG'

    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(
      `${API_PAYROLL_MONTHLY_SUMMARY_URL}?search=${query}`,
      token,
    );

    state.payroll.summaryResults = data.map(paysum => {
      const createdDate = paysum.created_at.toLocaleString().slice(0, 10);
      const updatedDate = paysum.updated_at.toLocaleString().slice(0, 10);
      return {
        id: paysum.id,
        uuid: paysum.uuid,
        period: paysum.period,
        totalCpfEmployee: paysum.total_cpf_employee,
        totalCpfEmployer: paysum.total_cpf_employer,
        totalSdl: paysum.total_sdl,
        totalShgCdac: paysum.total_shg_cdac,
        totalShgMbmf: paysum.total_shg_mbmf,
        totalShgSinda: paysum.total_shg_sinda,
        totalShgEcf: paysum.total_shg_ecf,
        totalShg: paysum.total_shg_all,
        totalCpf: paysum.total_cpf,
        totalCpfAll: paysum.total_cpf_all,
        createdAt: createdDate,
        updatedAt: updatedDate,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadLeaveTypeSearchResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(`${API_LEAVE_TYPE_URL}?search=${query}`, token);

    state.leave.leaveTypeResults = data.map(lv => {
      const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
      const updateDate = lv.update_date.toLocaleString().slice(0, 10);
      return {
        id: lv.id,
        name: lv.name,
        code: lv.code,
        carryForward: lv.carry_forward,
        maxCarryForwardDays: lv.max_carry_forward_days,
        allowHalfDay: lv.allow_half_day,
        isPaid: lv.is_paid,
        requiresAttachment: lv.requires_attachment,
        affectsPayRoll: lv.affects_payroll,
        insertDate: insertDate,
        updateDate: updateDate,
        active: lv.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadLeaveHolidaySearchResults = async function (
  query,
  filterFromDate,
) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(
      `${API_LEAVE_HOLIDAY_URL}?from_date=${filterFromDate}&search=${query}`,
      token,
    );

    state.leave.leaveHolidayResults = data.map(lv => {
      const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
      const updateDate = lv.update_date.toLocaleString().slice(0, 10);
      const date = lv.date.toLocaleString().slice(0, 10);
      // const countryName = state.user.country.find(
      //   ctry => ctry.code === lv.country,
      // ).name;
      return {
        id: lv.id,
        name: lv.name,
        country: lv.country,
        date: date,
        isHalfDay: lv.is_half_day,
        insertDate: insertDate,
        updateDate: updateDate,
        active: lv.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadLeavePolicySearchResults = async function (query) {
  try {
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(`${API_LEAVE_POLICY_URL}?search=${query}`, token);

    state.leave.leavePolicyResults = data.map(lv => {
      const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
      const updateDate = lv.update_date.toLocaleString().slice(0, 10);
      // const countryName = state.user.country.find(
      //   ctry => ctry.code === lv.country,
      // ).name;
      const leaveTypeName = lv.leave_type.name;
      const jobTitle = lv.job_title !== null ? lv.job_title.title : '';
      return {
        id: lv.id,
        name: lv.name,
        country: lv.country,
        leaveTypeName: leaveTypeName,
        jobTitle: jobTitle,
        minService: lv.min_years_of_service,
        maxService: lv.max_years_of_service,
        entitledDays: lv.entitlement_days,
        insertDate: insertDate,
        updateDate: updateDate,
        active: lv.active,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Leave Balance. Need to call twice as the login user employee leave balance should not be filtered by query
export const loadLeaveBalanceSearchResults = async function (
  query,
  filterFromDate,
) {
  try {
    const currentYear = new Date().getFullYear();
    const currentUserId = state.user.results.id;
    const token = localStorage.getItem('accesstoken');

    // 1️⃣ Filtered API (for table search)
    const data = await AJAX(
      `${API_LEAVE_BALANCE_URL}?from_insert_date=${filterFromDate}&search=${query}`,
      token,
    );

    state.leave.leaveBalanceResults = data.map(lv => {
      const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
      const updateDate = lv.update_date.toLocaleString().slice(0, 10);
      const leaveTypeName = lv.leave_type.name;
      const leaveTypeId = lv.leave_type.id;
      const employeeName = lv.employee.full_name;

      return {
        id: lv.id,
        employeeId: lv.employee_id,
        employeeName: employeeName,
        userId: lv.employee.user,
        leaveTypeId: leaveTypeId,
        leaveTypeName: leaveTypeName,
        year: lv.year,
        entitlement: +lv.entitlement,
        carriedForward: +lv.carried_forward,
        used: +lv.used,
        remaining: +lv.remaining,
        insertDate: insertDate,
        updateDate: updateDate,
        active: lv.active,
      };
    });

    // 2️⃣ Unfiltered API (for employee summary)
    const employeeData = await AJAX(
      `${API_LEAVE_BALANCE_URL}?from_insert_date=${filterFromDate}`,
      token,
    );

    state.leave.leaveBalanceEmployeeResults = employeeData
      .filter(
        lv => lv.employee.user === currentUserId && lv.year === currentYear,
      )
      .map(lv => {
        const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
        const updateDate = lv.update_date.toLocaleString().slice(0, 10);

        return {
          id: lv.id,
          employeeId: lv.employee_id,
          employeeName: lv.employee.full_name,
          userId: lv.employee.user,
          leaveTypeId: lv.leave_type.id,
          leaveTypeName: lv.leave_type.name,
          year: lv.year,
          entitlement: +lv.entitlement,
          carriedForward: +lv.carried_forward,
          used: +lv.used,
          remaining: +lv.remaining,
          insertDate: insertDate,
          updateDate: updateDate,
          active: lv.active,
        };
      });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const loadLeaveRequestSearchResults = async function (
  query,
  filterFromDate,
  tab,
) {
  try {
    const currentUserId = state.user.results.id;
    //Retrieve the token from the local storage and remove the double quote.
    const token = localStorage.getItem('accesstoken');

    //GET user API with Country Filter using search query and access token
    const data = await AJAX(
      `${API_LEAVE_REQUEST_URL}?from_insert_date=${filterFromDate}&search=${query}`,
      token,
    );

    const mapped = data.map(lv => {
      // const insertDate = lv.insert_date.toLocaleString().slice(0, 10);
      // const updateDate = lv.update_date.toLocaleString().slice(0, 10);
      const startDate = lv.start_date.toLocaleString().slice(0, 10);
      const endDate = lv.end_date.toLocaleString().slice(0, 10);
      const appliedDate = lv.applied_at.toLocaleString().slice(0, 10);
      const decisionDate =
        lv.decision_at !== null
          ? lv.decision_at.toLocaleString().slice(0, 10)
          : null;
      const leaveTypeName = lv.leave_type.name;
      const leaveTypeId = lv.leave_type.id;
      const employeeId = lv.employee.employee_id;
      const employeeName = lv.employee.full_name;
      const actionByName =
        lv.action_by !== null ? lv.action_by.full_name : null;
      const managerUserId = lv.employee.latest_job.manager_user_id;
      // const tabContextAdmin = 'admin';

      return {
        id: lv.id,
        employeeId: employeeId,
        employeeName: employeeName,
        userId: lv.employee.user,
        managerUserId: managerUserId,
        leaveTypeId: leaveTypeId,
        leaveTypeName: leaveTypeName,
        startDate: startDate,
        endDate: endDate,
        totalDays: +lv.total_days,
        reason: lv.reason,
        status: lv.status,
        attachment: lv.attachment,
        appliedDate: appliedDate,
        decisionDate: decisionDate,
        actionBy: actionByName,

        // _tabContext: tab, // for tabulator row formatter
        // insertDate: insertDate,
        // updateDate: updateDate,
        // active: lv.active,
      };
    });

    if (!tab) {
      state.leave.leaveRequestEmployeeResults = mapped
        .filter(r => r.userId === currentUserId)
        .map(r => ({ ...r, _tabContext: 'employee' }));

      state.leave.leaveRequestMyEmployeeResults = mapped
        .filter(r => r.managerUserId === currentUserId)
        .map(r => ({ ...r, _tabContext: 'manager' }));

      state.leave.leaveRequestResults = mapped
        .filter(r => r.userId !== currentUserId)
        .map(r => ({
          ...r,
          _tabContext: 'admin',
        }));
    }

    // store results based on tab
    if (tab === 'employee') {
      state.leave.leaveRequestEmployeeResults = mapped
        .filter(r => r.userId === currentUserId)
        .map(r => ({ ...r, _tabContext: 'employee' }));
    }

    if (tab === 'manager') {
      state.leave.leaveRequestMyEmployeeResults = mapped
        .filter(r => r.managerUserId === currentUserId)
        .map(r => ({ ...r, _tabContext: 'manager' }));
    }

    if (tab === 'admin') {
      state.leave.leaveRequestResults = mapped
        .filter(r => r.userId !== currentUserId)
        .map(r => ({
          ...r,
          _tabContext: 'admin',
        }));
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to calculate leave request total days
export const calculateLeaveRequestDays = async function (
  start,
  end,
  selectedHalfDay,
) {
  try {
    const token = localStorage.getItem('accesstoken');
    const data = await AJAX(
      `${API_LEAVE_REQUEST_CALCULATE_URL}?start=${start}&end=${end}&half_day=${selectedHalfDay}`,
      token,
    );
    return data.total_days; // must return the value to controller
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to get the leave request status from the url and return to show to Manager
export const leaveActionResult = function () {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('status');
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Audit Log
export const loadAuditLogSearchResults = async function (
  query,
  filterFromDate,
  filterToDate,
) {
  try {
    const token = localStorage.getItem('accesstoken');

    // 1️⃣ Filtered API (for table search)
    const data = await AJAX(
      `${API_AUDIT_LOG_URL}?from_insert_date=${filterFromDate}&to_insert_date=${filterToDate}&search=${query}`,
      token,
    );

    state.audit.logResults = data.map(lv => {
      // const createdDate = lv.created_at.toLocaleString().slice(0, 10);

      return {
        id: lv.id,
        actorName: lv.actor_name,
        appLabel: lv.app_label,
        modelName: lv.model_name,
        objectId: lv.object_id,
        action: lv.action,
        changes: lv.changes,
        ipAddress: lv.ip_address,
        browser: lv.browser,
        browserVersion: lv.browser_version,
        os: lv.os,
        osVersion: lv.os_version,
        deviceType: lv.device_type,
        userAgent: lv.user_agent,
        createdDate: lv.created_at,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Leave Balance. Need to call twice as the login user employee leave balance should not be filtered by query
export const loadAuditConfigSearchResults = async function (
  query,
  // filterFromDate,
  // filterToDate,
) {
  try {
    const token = localStorage.getItem('accesstoken');

    // 1️⃣ Filtered API (for table search)
    const data = await AJAX(`${API_AUDIT_CONFIG_URL}?search=${query}`, token);

    // 🔥 wrap single object into array
    const results = data ? (Array.isArray(data) ? data : [data]) : [];

    state.audit.configResults = results.map(lv => {
      return {
        enabled: lv.enabled,
        userId: lv.updated_by,
        userEmail: lv.user_email,
        updatedDate: lv.updated_at,
      };
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

/* UPDATE*/

// To update the edit of the Employee to the database

export const updateEmployee = async function (editedEmployee) {
  try {
    console.log(editedEmployee);
    console.log(state.user.allResult);
    // Convert to formats suitable to be populated to database
    state.employee.editDbResults = editedEmployee.map(emp => {
      let user = state.user.allResult.find(
        usr => usr.userEmail === emp.employeeUserEmail,
      ).id;
      // let citizenshipCountryCode = state.user.country.find(
      //   cty => cty.name === emp.employeeCitizenshipName,
      // ).code;

      return {
        employee_id: emp.id,
        user: user,
        first_name: emp.employeeFirstName,
        last_name: emp.employeeLastName,
        nick_name: emp.employeeNickName,
        work_mobile: emp.employeeWorkMobile,
        work_email: emp.employeeWorkEmail,
        personal_mobile: emp.employeePersonalMobile,
        personal_email: emp.employeePersonalEmail,
        address: emp.employeeAddress,
        unit_no: emp.employeeUnitNo,
        country: emp.employeeCountry,
        postcode: emp.employeePostcode,
        gender: emp.employeeGender,
        marital_status: emp.employeeMaritalStatus,
        citizenship: emp.employeeCitizenship,
        date_of_birth: emp.employeeBirthday,
        date_joined: emp.employeeJoinDate,
        date_left: emp.employeeLeftDate,
        active: emp.employeeActive,
        national_id: emp.employeeNationalID,
        fin_no: emp.employeeFinNo,
        work_pass_no: emp.employeeWorkPassNo,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.employee.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_EMPLOYEE_URL}${el.employee_id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To update the edit of the Customer to the database

export const updateEmergencyContact = async function (editedEmployees) {
  try {
    // Loop through each employee
    for (let emp of editedEmployees) {
      // Create separate records for primary and secondary contacts
      const contacts = [];

      if (emp.employeePrimaryContact && emp.employeePrimaryContact.name) {
        contacts.push({
          id: emp.employeePrimaryContact.id || null,
          employee: emp.id,
          name: emp.employeePrimaryContact.name,
          relationship: emp.employeePrimaryContact.relationship,
          email: emp.employeePrimaryContact.email,
          mobile: emp.employeePrimaryContact.mobile,
          address: emp.employeePrimaryContact.address,
          is_primary: true,
        });
      }

      if (emp.employeeSecondaryContact && emp.employeeSecondaryContact.name) {
        contacts.push({
          id: emp.employeeSecondaryContact.id || null,
          employee: emp.id,
          name: emp.employeeSecondaryContact.name,
          relationship: emp.employeeSecondaryContact.relationship,
          email: emp.employeeSecondaryContact.email,
          mobile: emp.employeeSecondaryContact.mobile,
          address: emp.employeeSecondaryContact.address,
          is_primary: false,
        });
      }

      // Loop through contacts
      for (let contact of contacts) {
        let method, url;

        if (contact.id) {
          // Existing contact → update
          method = 'PUT';
          url = `${API_EMERGENCY_CONTACTS_URL}${contact.id}/`; // updated URL
        } else {
          // New contact → create
          method = 'POST';
          url = `${API_EMERGENCY_CONTACTS_URL}`; // POST to base URL
          delete contact.id; // remove null id for POST
        }
        const token = localStorage.getItem('accesstoken');
        const data = await AJAX(url, token, contact, method);
        // console.log(
        //   `${method} contact for employee ${contact.employee}:`,
        //   data
        // );
      }
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To update the edit of the Ethnicity to the database

export const updateEthnicity = async function (editedEthnicity) {
  try {
    // Convert to formats suitable to be populated to database
    state.ethnicity.editDbResults = editedEthnicity.map(ety => {
      // let countryCode = state.user.country.find(
      //   cty => cty.name === ety.ethnicityCountry,
      // ).code;

      return {
        id: ety.id,
        name: ety.ethnicityName,
        country: ety.ethnicityCountry === '' ? null : ety.ethnicityCountry,
        active: ety.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.
    const method = 'PUT';
    const editDetails = state.ethnicity.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(`${API_ETHNICITY_URL}${el.id}/`, token, el, method);
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To update the edit of the Work Pass Type to the database

export const updateWorkPassType = async function (editedWorkPassType) {
  try {
    // Convert to formats suitable to be populated to database
    state.workpasstype.editDbResults = editedWorkPassType.map(wp => {
      // let countryCode = state.user.country.find(
      //   cty => cty.name === wp.workPassTypeCountry,
      // ).code;

      return {
        id: wp.id,
        name: wp.workPassTypeName,
        country: wp.workPassTypeCountry === '' ? null : wp.workPassTypeCountry,
        active: wp.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.workpasstype.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_WORK_PASS_TYPE_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// To update the edit of the res status to the database

export const updateResidentialStatus = async function (
  editedResidentialStatus,
) {
  try {
    // Convert to formats suitable to be populated to database
    state.residentialstatus.editDbResults = editedResidentialStatus.map(res => {
      // let countryCode = state.user.country.find(
      //   cty => cty.name === res.residentialStatusCountry,
      // ).code;

      return {
        id: res.id,
        name: res.residentialStatusName,
        country:
          res.residentialStatusCountry === ''
            ? null
            : res.residentialStatusCountry,
        active: res.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.residentialstatus.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_RESIDENTIAL_STATUS_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateDepartment = async function (editedDepartment) {
  try {
    // Convert to formats suitable to be populated to database
    state.department.editDbResults = editedDepartment.map(dep => {
      return {
        id: dep.id,
        name: dep.departmentName,
        description: dep.departmentDescription,
        active: dep.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.department.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_DEPARTMENT_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateJobTitle = async function (editedJobTitle) {
  try {
    // Convert to formats suitable to be populated to database
    state.jobtitle.editDbResults = editedJobTitle.map(jt => {
      return {
        id: jt.id,
        title: jt.jobTitle,
        description: jt.jobTitleDescription,
        level: jt.jobTitleLevel,
        active: jt.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.jobtitle.editDbResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(`${API_JOBTITLE_URL}${el.id}/`, token, el, method);
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateSdlRate = async function (editedSdlRate) {
  try {
    // Convert to formats suitable to be populated to database
    state.rate.sdlEditResults = editedSdlRate.map(sdl => {
      return {
        id: sdl.id,
        rate: sdl.sdlRate,
        min_amount: sdl.sdlMinAmount,
        max_amount: sdl.sdlMaxAmount,
        effective_date: sdl.effectiveDate,
        active: sdl.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.rate.sdlEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(`${API_SDL_RATE_URL}${el.id}/`, token, el, method);
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateShgRate = async function (editedShgRate) {
  try {
    // Convert to formats suitable to be populated to database
    state.rate.shgEditResults = editedShgRate.map(shg => {
      const ethnicity = state.ethnicity.results.find(
        etc => etc.ethnicityName === shg.shgEthnicityName,
      ).id;

      return {
        id: shg.id,
        group_name: shg.shgGroupName,
        ethnicity: ethnicity,
        contribution_amount: shg.shgContributionAmount,
        wages_min: shg.shgMinWage,
        wages_max: shg.shgMaxWage,
        effective_date: shg.effectiveDate,
        active: shg.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.rate.shgEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(`${API_SHG_RATE_URL}${el.id}/`, token, el, method);
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateCpfRate = async function (editedCpfRate) {
  try {
    // Convert to formats suitable to be populated to database
    state.rate.cpfEditResults = editedCpfRate.map(cpf => {
      const residentialStatus = state.residentialstatus.results.find(
        res => res.residentialStatusName === cpf.cpfResidentialStatusName,
      ).id;

      return {
        id: cpf.id,
        residential_status: residentialStatus,
        ordinary_wage_ceiling: cpf.cpfOWCeiling,
        additional_wage_ceiling: cpf.cpfAWCeiling,
        age_min: cpf.cpfMinAge,
        age_max: cpf.cpfMaxAge,
        total_wages_min: cpf.cpfMinWage,
        total_wages_max: cpf.cpfMaxWage,
        total_rate: cpf.cpfTotalRate,
        employee_rate: cpf.cpfEmployeeRate,
        effective_date: cpf.effectiveDate,
        active: cpf.active,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.

    const method = 'PUT';
    const editDetails = state.rate.cpfEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(`${API_CPF_RATE_URL}${el.id}/`, token, el, method);
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateLeaveType = async function (editedLeaveType) {
  try {
    // Convert to formats suitable to be populated to database
    state.leave.leaveTypeEditResults = editedLeaveType.map(lv => {
      return {
        id: lv.id,
        name: lv.name,
        code: lv.code,
        max_carry_forward_days: lv.maxCarryForwardDays,
        carry_forward: lv.carryForward,
        allow_half_day: lv.allowHalfDay,
        is_paid: lv.isPaid,
        affects_payroll: lv.affectsPayRoll,
        requires_attachment: lv.requiresAttachment,
        active: lv.active,
      };
    });

    const method = 'PUT';
    const editDetails = state.leave.leaveTypeEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_LEAVE_TYPE_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateLeaveHoliday = async function (editedLeaveHoliday) {
  try {
    // Convert to formats suitable to be populated to database
    state.leave.leaveHolidayEditResults = editedLeaveHoliday.map(lv => {
      // let countryCode = state.user.country.find(
      //   cty => cty.name === lv.country,
      // ).code;

      return {
        id: lv.id,
        name: lv.name,
        date: lv.date,
        country: lv.country === '' ? null : lv.country,
        is_half_day: lv.isHalfDay,
        active: lv.active,
      };
    });

    const method = 'PUT';
    const editDetails = state.leave.leaveHolidayEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_LEAVE_HOLIDAY_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateLeavePolicy = async function (editedLeavePolicy) {
  try {
    // Convert to formats suitable to be populated to database
    state.leave.leavePolicyEditResults = editedLeavePolicy.map(lv => {
      let leaveTypeId = state.leave.leaveTypeResults.find(
        leave => leave.name === lv.leaveTypeName,
      ).id;

      let jobTitleId =
        lv.jobTitle !== ''
          ? state.jobtitle.results.find(jt => jt.jobTitle === lv.jobTitle).id
          : null;

      return {
        id: lv.id,
        leave_type_id: leaveTypeId,
        job_title_id: jobTitleId,
        country: lv.country === '' ? null : lv.country,
        min_years_of_service: lv.minService || 0,
        max_years_of_service: lv.maxService === '' ? null : lv.maxService,
        entitlement_days: lv.entitledDays,
        active: lv.active,
      };
    });

    const method = 'PUT';
    const editDetails = state.leave.leavePolicyEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_LEAVE_POLICY_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateLeaveBalance = async function (editedLeaveBalance) {
  try {
    // Convert to formats suitable to be populated to database
    state.leave.leaveBalanceEditResults = editedLeaveBalance.map(lv => {
      let leaveTypeId = state.leave.leaveBalanceResults.find(
        leave => leave.leaveTypeName === lv.leaveTypeName,
      ).leaveTypeId;
      return {
        id: lv.id,
        leave_type_id: leaveTypeId,
        employee_id: lv.employeeId,
        year: lv.year,
        entitlement: lv.entitlement,
        carried_forward: lv.carriedForward,
        used: lv.used,
        remaining: lv.remaining,
        active: lv.active,
      };
    });

    const method = 'PUT';
    const editDetails = state.leave.leaveBalanceEditResults;
    for (let el of editDetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_LEAVE_BALANCE_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const updateLeaveRequestApproval = async function (selectedRow) {
  try {
    const leaveRequestId = selectedRow.id;
    const token = localStorage.getItem('accesstoken');
    const method = 'PATCH';
    const data = await AJAX(
      `${API_LEAVE_REQUEST_URL}${leaveRequestId}/approve/`,
      token,
      {}, // body (empty)
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const updateLeaveRequestRejection = async function (selectedRow) {
  try {
    const leaveRequestId = selectedRow.id;
    const leaveRequestReason = selectedRow.reason;
    const token = localStorage.getItem('accesstoken');
    const method = 'PATCH';
    const data = await AJAX(
      `${API_LEAVE_REQUEST_URL}${leaveRequestId}/reject/`,
      token,
      { reason: leaveRequestReason },
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//This is used to retrieve the Work Pass Type list
export const updateLeaveRequestCancel = async function (selectedRow) {
  try {
    const leaveRequestId = selectedRow.id;
    const leaveRequestReason = selectedRow.reason;
    const token = localStorage.getItem('accesstoken');
    const method = 'PATCH';
    const data = await AJAX(
      `${API_LEAVE_REQUEST_URL}${leaveRequestId}/cancel/`,
      token,
      { reason: leaveRequestReason },
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateAuditConfig = async function (editedAuditConfig) {
  try {
    // Only take first item (since single config row)
    const data = {
      enabled: editedAuditConfig[0].enabled,
    };

    const token = localStorage.getItem('accesstoken');
    const method = 'PATCH';

    await AJAX(`${API_AUDIT_CONFIG_URL}`, token, data, method);
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// This will update the User details directly to SSO. SSO will propagate the changes down to all connnected services

export const updateUser = async function (editedUser) {
  try {
    // Convert to formats suitable to be populated to database for SSO
    state.user.editDbResultsSSO = editedUser.map(user => {
      // Find the id of the org (by comparing the branch name) to be sent to database
      const editedOrg = state.organization.cmsResults.find(
        x => x.branchName === user.userBranch,
      ).id;

      const userActive = user.userActive === 'N' ? false : true; // change user is_active from Y/N to true/false

      state.user.editgroup = [];

      // Push the id into an array as groups can only accept arrays
      state.user.editgroup.push(user.userGroup);

      return {
        id: user.id,
        mobile: user.userMobile,
        first_name: user.userFirstName,
        last_name: user.userLastName,
        nick_name: user.userNickName,
        organization: editedOrg,
        groups: state.user.editgroup,
        is_active: userActive,
      };
    });

    //Call AJAX to update the edit to database using PUT method. Access token is retrieved from local Storage.
    const method = 'PATCH'; // Use PUT when updating all fields (you must include required ones). Use PATCH for partial updates (include only what you want to change).

    // Update user details in SSO
    const editSSODetails = state.user.editDbResultsSSO;
    for (let el of editSSODetails) {
      const token = localStorage.getItem('accesstoken');
      let data = await AJAX(
        `${API_UPDATE_USER_URL}${el.id}/`,
        token,
        el,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

/* ADD NEW RECORD*/

//To add a new employee entered via UI form
export const addNewEmployee = async function (newEmp) {
  try {
    const token = localStorage.getItem('accesstoken');
    const employeeObj = Object.fromEntries([...newEmp]); // convert FormData to object
    const employeeId = employeeObj.id;

    // Convert employee user email → user id here, and replace 'user' in the object
    if (employeeObj.user) {
      let user = state.user.allResult.find(
        user => user.userEmail === employeeObj.user,
      )?.id; //Optional Chaining: Without ?., trying to do undefined.code would throw an error. With ?., JavaScript safely returns undefined instead of crashing.

      if (user) {
        newEmp.set('user', user); // overwrite the user in FormData
      }
    }

    // console.log(...newEmp);

    // // Convert citizenship country name → code here
    // if (employeeObj.citizenship) {
    //   let countryCode = state.user.country.find(
    //     cty => cty.name === employeeObj.citizenship,
    //   )?.code; //Optional Chaining: Without ?., trying to do undefined.code would throw an error. With ?., JavaScript safely returns undefined instead of crashing.

    //   if (countryCode) {
    //     newEmp.set('citizenship', countryCode); // overwrite the country in FormData
    //   }
    // }

    // Upload new employee or amend an existing employee by calling sendFormData to post it via API call. FormData structure instead of Json is required for file upload
    // If employee id is not existing, create a new employee
    if (!employeeId) {
      const method = 'POST';
      const uploaddata = await AJAXFILE(
        `${API_EMPLOYEE_URL}`,
        token,
        newEmp,
        method,
      );
      state.employee.uploadedResult = uploaddata;
      // If employee id is existing, amend the existing employee
    } else {
      const method = 'PUT';
      const uploaddata = await AJAXFILE(
        `${API_EMPLOYEE_URL}${employeeId}/`,
        token,
        newEmp,
        method,
      );
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Job Detail entered via UI form or throught UI form Edit
export const addNewJobDetail = async function (newJobDetail) {
  try {
    const isHR = state.employee.results[0].isHR;
    if (!isHR) return;
    // If job detail id is "", it means it is a newly added employee, thus use the uploaded result employee id, else it is Edit, and use the edited row employee id
    let employeeId =
      newJobDetail.id === ''
        ? state.employee.uploadedResult.employee_id
        : Number(newJobDetail.id);

    let organizationId = state.organization.hrmResults.find(
      org => org.name === newJobDetail.organization,
    ).id;

    let jobTitleId = state.jobtitle.results.find(
      jt => jt.jobTitle === newJobDetail.job_title,
    ).id;

    let managerId = state.employee.results.find(
      emp => emp.employeeNickName === newJobDetail.manager,
    ).id;

    let departmentId = Number(newJobDetail.department);

    //convert to API package format
    const jobDetailCreated = {
      employee: employeeId,
      job_title: jobTitleId,
      department: departmentId,
      manager: managerId,
      organization: organizationId,
      id: newJobDetail.job_detail_id,
      start_date: newJobDetail.start_date,
    };

    // Below is to check if there are any changes made to Job Details, skip creation if there are no changes

    // check existing Job Detail
    const existingJobDetail =
      newJobDetail.id !== ''
        ? state.employee.results.find(jd => jd.id === employeeId)
        : null;

    const isSameJobDetail =
      existingJobDetail &&
      existingJobDetail.id === jobDetailCreated.employee &&
      existingJobDetail.employeeCurrentJobTitleId ===
        jobDetailCreated.job_title &&
      existingJobDetail.employeeCurrentDepartmentId ===
        jobDetailCreated.department &&
      existingJobDetail.employeeCurrentManagerId === jobDetailCreated.manager &&
      existingJobDetail.employeeCurrentOrgId ===
        jobDetailCreated.organization &&
      existingJobDetail.employeeCurrentJobDetailStartDate ===
        jobDetailCreated.start_date;

    if (isSameJobDetail) {
      console.log('No changes in Job Detail — skipping creation.');
      return;
    }

    //Upload new Job Detail by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const uploaddata = await AJAX(
      `${API_POSTJOBDETAIL_URL}`,
      token,
      jobDetailCreated,
      'POST',
    );

    // // 2. PATCH old job detail with end_date (if any)
    // if (jobDetailCreated.id) {
    //   const todayDate = new Date().toISOString().slice(0, 10);
    //   const patchPayload = { end_date: todayDate };
    //   await AJAX(
    //     `${API_POSTJOBDETAIL_URL}${jobDetailCreated.id}/`,
    //     token,
    //     patchPayload,
    //     'PATCH'
    //   );
    //   console.log(
    //     `Patched old job detail ${jobDetailCreated.id} with end_date`
    //   );
    // }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Job Detail entered via row edit
export const addNewJobDetailInline = async function (editedJobDetail) {
  try {
    const isHR = state.employee.results[0].isHR;
    if (!isHR) return;

    state.jobdetail.editDbResults = editedJobDetail.map(job => {
      let organizationId = state.organization.hrmResults.find(
        org => org.name === job.employeeCurrentOrgName,
      ).id;

      let jobTitleId = state.jobtitle.results.find(
        jt => jt.jobTitle === job.employeeCurrentJobTitle,
      ).id;

      let managerId = state.employee.results.find(
        emp => emp.employeeNickName === job.employeeCurrentManagerName,
      ).id;

      let departmentId = state.department.results.find(
        dep => dep.departmentName === job.employeeCurrentDepartment,
      ).id;

      //convert to API format
      return {
        employee: job.id,
        job_title: jobTitleId,
        department: departmentId,
        manager: managerId,
        organization: organizationId,
        id: job.employeeCurrentJobDetailId,
        start_date: job.employeeCurrentJobDetailStartDate,
      };
    });

    //Upload new Job Detail by calling sendJSON to post it via API call
    const method = 'POST';
    // Update all newly edited Job Details via POST as job details history will not be overwritten
    const editJobDetails = state.jobdetail.editDbResults;
    for (let el of editJobDetails) {
      // Below is to check if there are any changes made to Job Details, skip creation if there are no changes
      const existingJobDetail = state.employee.originalResults.find(
        jd => jd.id === el.employee,
      );

      const isSameJobDetail =
        existingJobDetail &&
        existingJobDetail.id === el.employee &&
        existingJobDetail.employeeCurrentJobTitleId === el.job_title &&
        existingJobDetail.employeeCurrentDepartmentId === el.department &&
        existingJobDetail.employeeCurrentManagerId === el.manager &&
        existingJobDetail.employeeCurrentOrgId === el.organization &&
        existingJobDetail.employeeCurrentJobDetailStartDate === el.start_date;

      // If nothing changed → skip and will not POST or PATCH.  Note that we are comparing exact string and thus the order of the fields matter
      if (isSameJobDetail) {
        console.log(
          `No changes for employee ${el.employee} job detail — skipping POST`,
        );
        continue; // ⏭ skip to next employee
      }
      // POST to add a new Job Detail if there are changes to Job Detail
      const token = localStorage.getItem('accesstoken');
      const uploaddata = await AJAX(
        `${API_POSTJOBDETAIL_URL}`,
        token,
        el,
        'POST',
      );
      // // 2. PATCH old job detail with end_date (if any)
      // if (el.id) {
      //   const todayDate = new Date().toISOString().slice(0, 10);
      //   const patchPayload = { end_date: todayDate };
      //   await AJAX(
      //     `${API_POSTJOBDETAIL_URL}${el.id}/`,
      //     token,
      //     patchPayload,
      //     'PATCH'
      //   );
      //   console.log(`Patched old job detail ${el.id} with end_date`);
      // }
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Salary entered via UI form or throught UI form Edit
export const addNewSalary = async function (newSalary) {
  try {
    const isHR = state.employee.results[0].isHR;

    if (!isHR) return;
    // If employee id is "", it means it is a newly added employee, thus use the uploaded result employee id, else it is Edit, and use the edited row employee id
    let employeeId =
      newSalary.id === ''
        ? state.employee.uploadedResult.employee_id
        : Number(newSalary.id);

    //convert to API package format
    const salaryCreated = {
      employee: employeeId,
      base_salary: Number(newSalary.base_salary),
      annual_wage_supplement: Number(newSalary.annual_wage_supplement || 0),
      allowance_transport: Number(newSalary.allowance_transport || 0),
      allowance_other: Number(newSalary.allowance_othe || 0),
      deduction_charity: Number(newSalary.deduction_charity || 0),
      deduction_other: Number(newSalary.deduction_other || 0),
      deduction_comchest: Number(newSalary.deduction_comchest || 0),
      pay_frequency: newSalary.pay_frequency,
      effective_date: newSalary.effective_date,
      id: newSalary.salary_id,
    };

    // Below is to check if there are any changes made to Salary, skip creation if there are no changes

    // Retrieve the existing OR newly created employee salary info by matching the existing OR newly created employee id
    const existingSalary =
      newSalary.id !== ''
        ? state.employee.results.find(sal => sal.id === employeeId)
        : null;

    // Check all fields of Salary to determine if any changes made to any of the fields
    const isSameSalary =
      existingSalary &&
      existingSalary.id === salaryCreated.employee &&
      Number(existingSalary.employeeCurrentBaseSalary) ===
        salaryCreated.base_salary &&
      Number(existingSalary.employeeCurrentAnnualWageSupplement) ===
        salaryCreated.annual_wage_supplement &&
      Number(existingSalary.employeeCurrentTransportAllowance) ===
        salaryCreated.allowance_transport &&
      Number(existingSalary.employeeCurrentOtherAllowance) ===
        salaryCreated.allowance_other &&
      Number(existingSalary.employeeCurrentCharityDeduction) ===
        salaryCreated.deduction_charity &&
      Number(existingSalary.employeeCurrentOtherDeduction) ===
        salaryCreated.deduction_other &&
      Number(existingSalary.employeeCurrentComchestDeduction) ===
        salaryCreated.deduction_comchest &&
      existingSalary.employeeCurrentPayFrequency ===
        salaryCreated.pay_frequency &&
      existingSalary.employeeCurrentSalaryEffectiveDate ===
        salaryCreated.effective_date;

    // console.log(
    //   Number(existingSalary.employeeCurrentBaseSalary),
    //   salaryCreated.base_salary
    // );
    // console.log(
    //   Number(existingSalary.employeeCurrentAnnualWageSupplement),
    //   salaryCreated.annual_wage_supplement
    // );
    // console.log(
    //   Number(existingSalary.employeeCurrentTransportAllowance) ===
    //     salaryCreated.allowance_transport
    // );
    // console.log(
    //   Number(existingSalary.employeeCurrentOtherAllowance) ===
    //     salaryCreated.allowance_other
    // );
    // console.log(
    //   Number(existingSalary.employeeCurrentCharityDeduction) ===
    //     salaryCreated.deduction_charity
    // );
    // console.log(
    //   Number(existingSalary.employeeCurrentOtherDeduction) ===
    //     salaryCreated.deduction_other
    // );

    // console.log(
    //   existingSalary.employeeCurrentPayFrequency === salaryCreated.pay_frequency
    // );
    // console.log(
    //   existingSalary.employeeCurrentSalaryEffectiveDate ===
    //     salaryCreated.effective_date
    // );

    // console.log('isSameSalary:', isSameSalary);

    // console.log(isSameSalary);

    // Skip Salary creation if there are no changes
    if (isSameSalary) {
      console.log('No changes in Salary— skipping creation.');
      return;
    }

    //Upload new Salary by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const uploaddata = await AJAX(
      `${API_SALARY_URL}`,
      token,
      salaryCreated,
      'POST',
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// via row edit
export const addNewSalaryInline = async function (editedSalary) {
  try {
    const isHR = state.employee.results[0].isHR;
    if (!isHR) return;
    // 2️⃣ Convert edited salaries into API format (force primitive copies)
    state.salary.editDbResults = editedSalary.map(sal => {
      return {
        employee: sal.id,
        base_salary: Number(sal.employeeCurrentBaseSalary),
        annual_wage_supplement: Number(
          sal.employeeCurrentAnnualWageSupplement || 0,
        ),
        allowance_transport: Number(sal.employeeCurrentTransportAllowance || 0),
        allowance_other: Number(sal.employeeCurrentOtherAllowance || 0),
        deduction_charity: Number(sal.employeeCurrentCharityDeduction || 0),
        deduction_other: Number(sal.employeeCurrentOtherDeduction || 0),
        deduction_comchest: Number(sal.employeeCurrentComchestDeduction || 0),
        pay_frequency: sal.employeeCurrentPayFrequency,
        effective_date: sal.employeeCurrentSalaryEffectiveDate,
        id: sal.employeeCurrentSalaryId,
      };
    });

    // console.log('Edit DB Results:', state.salary.editDbResults);

    // 3️⃣ Upload new Salary by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const editSalary = state.salary.editDbResults;

    for (let el of editSalary) {
      // Find the OLD snapshot (not the mutated one)
      const existingSalary = state.employee.originalResults.find(
        jd => jd.id === el.employee,
      );

      // console.log(
      //   'Compare base salary:',
      //   Number(existingSalary.employeeCurrentBaseSalary),
      //   el.base_salary
      // );

      // 4️⃣ Check if salary actually changed
      const isSameSalary =
        existingSalary &&
        existingSalary.id === el.employee &&
        Number(existingSalary.employeeCurrentBaseSalary) === el.base_salary &&
        Number(existingSalary.employeeCurrentAnnualWageSupplement) ===
          el.annual_wage_supplement &&
        Number(existingSalary.employeeCurrentTransportAllowance) ===
          el.allowance_transport &&
        Number(existingSalary.employeeCurrentOtherAllowance) ===
          el.allowance_other &&
        Number(existingSalary.employeeCurrentCharityDeduction) ===
          el.deduction_charity &&
        Number(existingSalary.employeeCurrentOtherDeduction) ===
          el.deduction_other &&
        Number(existingSalary.employeeCurrentComchestDeduction) ===
          el.deduction_comchest &&
        existingSalary.employeeCurrentPayFrequency === el.pay_frequency &&
        existingSalary.employeeCurrentSalaryEffectiveDate === el.effective_date;

      // console.log(
      //   Number(existingSalary.employeeCurrentBaseSalary) === el.base_salary
      // );
      // console.log(
      //   Number(existingSalary.employeeCurrentAnnualWageSupplement),
      //   el.annual_wage_supplement
      // );
      // console.log(
      //   Number(existingSalary.employeeCurrentTransportAllowance) ===
      //     el.allowance_transport
      // );
      // console.log(
      //   Number(existingSalary.employeeCurrentOtherAllowance) ===
      //     el.allowance_other
      // );
      // console.log(
      //   Number(existingSalary.employeeCurrentCharityDeduction) ===
      //     el.deduction_charity
      // );
      // console.log(
      //   Number(existingSalary.employeeCurrentOtherDeduction) ===
      //     el.deduction_other
      // );

      // console.log(
      //   existingSalary.employeeCurrentPayFrequency === el.pay_frequency
      // );
      // console.log(
      //   existingSalary.employeeCurrentSalaryEffectiveDate === el.effective_date
      // );

      // console.log('isSameSalary:', isSameSalary);

      // 5️⃣ Skip if no changes
      if (isSameSalary) {
        console.log(
          `No changes for employee ${el.employee} salary — skipping POST`,
        );
        continue;
      }

      // 6️⃣ Otherwise POST a new salary record
      const token = localStorage.getItem('accesstoken');
      const uploaddata = await AJAX(`${API_SALARY_URL}`, token, el, 'POST');
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new treatment entered via UI form
export const addNewEmergencyContact = async function (newEC) {
  try {
    // Upload new contact or amend an existing contact by calling via API call.
    // If contact id is not existing, create a new record

    for (let el of newEC) {
      const token = localStorage.getItem('accesstoken');
      if (!el.id) {
        let employeeId = state.employee.uploadedResult.employee_id;
        // Attach employee to payload before POST
        el.employee = employeeId;
        const uploaddata = await AJAX(
          `${API_EMERGENCY_CONTACTS_URL}`,
          token,
          el,
          'POST',
        );
        // If employee id is existing, amend the existing employee
      } else {
        const uploaddata = await AJAX(
          `${API_EMERGENCY_CONTACTS_URL}${el.id}/`,
          token,
          el,
          'PATCH',
        );
      }
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Payroll/CPF calculation
export const addNewCalcSalary = async function (newCalcSalary) {
  try {
    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_POST_PAYROLL_TRANSACTION_URL}`,
      token,
      newCalcSalary,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Ethnicity
export const addNewEthnicity = async function (newEthnicity) {
  try {
    //convert to API package format
    const ethnicityCreated = {
      name: newEthnicity.ethnicityname,
      country: newEthnicity.ethnicitycountry,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_ETHNICITY_URL}`,
      token,
      ethnicityCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new WorkPassType
export const addNewWorkPassType = async function (newWorkPassType) {
  try {
    //convert to API package format
    const workPassTypeCreated = {
      name: newWorkPassType.workpasstypename,
      country: newWorkPassType.workpasstypecountry,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_WORK_PASS_TYPE_URL}`,
      token,
      workPassTypeCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Residential Status
export const addNewResidentialStatus = async function (newResidentialStatus) {
  try {
    //convert to API package format
    const residentialStatusCreated = {
      name: newResidentialStatus.residentialstatusname,
      country: newResidentialStatus.residentialstatuscountry,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_RESIDENTIAL_STATUS_URL}`,
      token,
      residentialStatusCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Department
export const addNewDepartment = async function (newDepartment) {
  try {
    //convert to API package format
    const departmentCreated = {
      name: newDepartment.departmentname,
      description: newDepartment.departmentdescription,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_DEPARTMENT_URL}`,
      token,
      departmentCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new JobTitle
export const addNewJobTitle = async function (newJobTitle) {
  try {
    //convert to API package format
    const jobTitleCreated = {
      title: newJobTitle.jobtitletitle,
      description: newJobTitle.jobtitledescription,
      level: newJobTitle.jobtitlelevel,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_JOBTITLE_URL}`,
      token,
      jobTitleCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new SDL Rate
export const addNewSdlRate = async function (newSdlRate) {
  try {
    //convert to API package format
    const sdlRateCreated = {
      rate: newSdlRate.sdlraterate,
      min_amount: newSdlRate.sdlratemin,
      max_amount: newSdlRate.sdlratemax,
      effective_date: newSdlRate.sdlrateeffectivedate,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_SDL_RATE_URL}`,
      token,
      sdlRateCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new SHG Rate
export const addNewShgRate = async function (newShgRate) {
  try {
    //convert to API package format
    const shgRateCreated = {
      group_name: newShgRate.shgrategroupname,
      ethnicity: newShgRate.shgrateethnicity,
      contribution_amount: newShgRate.shgratecontributionamount,
      wages_min: newShgRate.shgrateminwages,
      wages_max: newShgRate.shgratemaxwages,
      effective_date: newShgRate.shgrateeffectivedate,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_SHG_RATE_URL}`,
      token,
      shgRateCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new SHG Rate
export const addNewCpfRate = async function (newCpfRate) {
  try {
    //convert to API package format
    const cpfRateCreated = {
      residential_status: newCpfRate.cpfrateresidentialstatus,
      age_min: newCpfRate.cpfrateminage,
      age_max: newCpfRate.cpfratemaxage,
      total_rate: newCpfRate.cpfratetotalrate,
      employee_rate: newCpfRate.cpfrateemployeerate,
      ordinary_wage_ceiling: newCpfRate.cpfrateowceiling,
      additional_wage_ceiling: newCpfRate.cpfrateawceiling,
      total_wages_min: newCpfRate.cpfratemintotalwages,
      total_wages_max: newCpfRate.cpfratemaxtotalwages,
      effective_date: newCpfRate.cpfrateeffectivedate,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_CPF_RATE_URL}`,
      token,
      cpfRateCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new SHG Rate
export const addNewLeaveType = async function (lv) {
  try {
    //convert to API package format
    const leaveTypeCreated = {
      name: lv.leavetypename,
      code: lv.leavetypecode,
      max_carry_forward_days: lv.leavetypemaxcarrydays,
      carry_forward: lv.leavetypeallowcarryforward,
      is_paid: lv.leavetypeispaid,
      allow_half_day: lv.leavetypeallowhalfday,
      requires_attachment: lv.leavetyperequireattachment,
      affects_payroll: lv.leavetypeaffectpayroll,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_LEAVE_TYPE_URL}`,
      token,
      leaveTypeCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new SHG Rate
export const addNewLeaveHoliday = async function (lv) {
  try {
    //convert to API package format
    const leaveHolidayCreated = {
      name: lv.leaveholidayname,
      is_half_day: lv.leaveholidayishalfday,
      date: lv.leaveholidaydate,
      country: lv.leaveholidaycountry,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_LEAVE_HOLIDAY_URL}`,
      token,
      leaveHolidayCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Leave Policy
export const addNewLeavePolicy = async function (lv) {
  try {
    // convert to API package format
    let jobTitleId =
      lv.leavepolicyjobtitle !== ''
        ? state.jobtitle.results.find(
            jt => jt.jobTitle === lv.leavepolicyjobtitle,
          ).id
        : null;

    const leavePolicyCreated = {
      leave_type_id: lv.leavepolicyleavetype,
      job_title_id: jobTitleId,
      country: lv.leavepolicycountry === '' ? null : lv.leavepolicycountry,
      min_years_of_service: lv.leavepolicyminyearsofservice || 0,
      max_years_of_service:
        lv.leavepolicymaxyearsofservice === ''
          ? null
          : lv.leavepolicymaxyearsofservice,
      entitlement_days: lv.leavepolicyentitlementdays,
    };

    // console.log(lv);
    // console.log(leavePolicyCreated);

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_LEAVE_POLICY_URL}`,
      token,
      leavePolicyCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Leave Policy
export const addNewLeaveBalance = async function (lv) {
  try {
    //convert to API package format
    let employeeId =
      lv.leavebalanceemployee !== ''
        ? state.employee.results.find(
            emp => emp.employeeNickName === lv.leavebalanceemployee,
          ).id
        : null;

    const leaveBalanceCreated = {
      leave_type_id: lv.leavebalanceleavetype,
      employee_id: employeeId,
      year: lv.leavebalanceyear,
      entitlement: +lv.leavebalanceentitlement,
      //   lv.leavepolicymaxyearsofservice === ''
      //     ? null
      //     : lv.leavepolicymaxyearsofservice,
      // entitlement_days: lv.leavepolicyentitlementdays,
    };

    // Upload new leave balance by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_LEAVE_BALANCE_URL}`,
      token,
      leaveBalanceCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new Leave Policy
export const addNewLeaveRequest = async function (leaveRequestFormData) {
  try {
    // console.log(lv);
    // //convert to API package format
    // let employeeId =
    //   lv.leavebalanceemployee !== ''
    //     ? state.employee.results.find(
    //         emp => emp.employeeNickName === lv.leavebalanceemployee,
    //       ).id
    //     : null;

    // const leaveRequestCreated = {
    //   leave_type_id: lv.leaverequestleavetypeid,
    //   start_date: lv.leaverequeststartdate,
    //   end_date: lv.leaverequestenddate,
    //   half_day: lv.leaverequesthalfday,
    //   reason: lv.leaverequestreason,
    // };

    // Upload new leave balance by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAXFILE(
      `${API_LEAVE_REQUEST_URL}`,
      token,
      leaveRequestFormData,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new user entered via UI form. This will add a new User to SSO. SSO will propagate the new user to all connected services
export const addNewUser = async function (newUser) {
  try {
    const userGroup = [newUser.userGroupName];
    //convert to API package format
    const userCreated = {
      first_name: newUser.firstname,
      last_name: newUser.lastname,
      nick_name: newUser.nickname,
      email: newUser.email,
      mobile: newUser.mobile,
      password: newUser.password,
      organization: state.user.ssoResults.orgId, // using the request user org (from sso) as the default for the new user org
      groups: userGroup,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_CREATE_USER_URL}`,
      token,
      userCreated,
      method,
    );

    // to use the below to create a new connection
    state.user.connection = {
      user: uploaddata.id,
      service: state.service.cmsResult.id,
    };
  } catch (err) {
    console.error(err);
    throw err;
  }
};

//To add a new connection
export const addNewConnection = async function (newConnect) {
  try {
    //convert to API package format
    const connectionCreated = {
      user: newConnect.user,
      service: newConnect.service,
    };

    //Upload new user by calling sendJSON to post it via API call
    const token = localStorage.getItem('accesstoken');
    const method = 'POST';
    const uploaddata = await AJAX(
      `${API_CONNECTION_URL}`,
      token,
      connectionCreated,
      method,
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

/* DELETE */

// //To update Package statuses. This is used when click on Cart Manual Pay to change the Package status from Pending to New
// export const deletePackage = async function (packages) {
//   try {
//     // Convert to formats suitable to be populated to database
//     state.package.deleteDbResults = packages.map(pack => {
//       return {
//         package_id: pack.id,
//       };
//     });
//     //Call AJAX to update the delete to database using DELETE method. Access token is retrieved from local Storage.
//     const token = localStorage.getItem('accesstoken');
//     const method = 'DELETE';
//     const deleteDetails = state.package.deleteDbResults;

//     for (let el of deleteDetails) {
//       let data = await AJAX(
//         `${API_PACKAGES_URL}${el.package_id}/`,
//         token,
//         el,
//         method
//       );
//     }
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

/* DROPDOWN LISTS*/

/* CHARTS*/

// // To convert package objects array from database to formats suitable to be populated to tables. Return only fields required for charting.
// const createChartObject = function (data) {
//   return data.map(pkg => {
//     //Change the object names and bring treatment name to the first array level via array map if there is only <= 1 treatment
//     const [treatName] =
//       pkg.packagedetails.length <= 1
//         ? pkg.packagedetails.map(det => det.treatment_name)
//         : 'M';

//     // This needs to be calculated from the payment balance as only the latest subpayments are captured and not all subpayments are captured
//     const totalPaid =
//       +pkg.price_bought +
//       (+pkg.total_price - +pkg.price_bought - +pkg.payment_balance);

//     return {
//       custName: pkg.customer_nickName,
//       treatmentName: treatName,
//       dateBought: pkg.date_bought,
//       priceBought: pkg.price_bought,
//       priceUsed: pkg.price_used,
//       priceBalance: pkg.price_balance,
//       branch: pkg.branch,
//       user: pkg.user,
//       totalPaid: totalPaid,
//     };
//   });
// };

// // API call to Package API for chart creation purposes
// const loadChartSearchResults = async function (
//   query,
//   filterFromDate,
//   filterToDate
// ) {
//   try {
//     // to retrieve the package status id from database
//     const statusQuery = 'Package Status';
//     await loadPackageStatus(statusQuery);

//     // find the package status Pending id
//     const packagePendingStatusId = state.package.status.find(
//       x => x.status === 'Pending'
//     ).id;
//     state.search.query = query;

//     //Retrieve the token from the local storage and remove the double quote.
//     const token = localStorage.getItem('accesstoken');
//     //GET packages API using search query and access token
//     const data = await AJAX(
//       `${API_PACKAGES_URL}?from_bought_date=${filterFromDate}&to_bought_date=${filterToDate}&search=${query}`,
//       token
//     );
//     //Call the function to convert the Objects format to populate to tables, and filter out Pending status packages
//     state.search.chartresults = createChartObject(
//       data.filter(pkg => pkg.status !== packagePendingStatusId)
//     );
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

// // To load the Sales Chart
// export const loadSalesChartSearchResults = async function (
//   query,
//   filterFromDate,
//   filterToDate,
//   branch
// ) {
//   try {
//     // To call the package API only for the first time and not when using filters, else it will take time to load
//     if (branch === undefined) {
//       await loadChartSearchResults(query, filterFromDate, filterToDate);
//       branch = 'All';
//     }

//     // To filter the array based on user filter selection. Need to amend here if new filters are added
//     let filteredSalesData = state.search.chartresults.filter(
//       item => branch === 'All' || item.branch === branch
//       // && (user === 'All' || item.user === user))
//     );

//     // Sum the total Sales based on month-year
//     state.chart.monthlySales = createMonthlySalesObject(filteredSalesData);

//     // To sort the data by month-year
//     state.chart.sortedMonthlySales = sortChartData(state.chart.monthlySales);

//     // To create the required Array format for eCharts
//     state.chart.monthlySalesData = createChartDataArray(
//       state.chart.sortedMonthlySales
//     );
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

// // To load the Customer Sales Chart
// export const loadCustomerChartSearchResults = async function (
//   query,
//   filterFromDate,
//   filterToDate
// ) {
//   try {
//     await loadChartSearchResults(query, filterFromDate, filterToDate);

//     state.chart.customerSales = createCustomerSalesObject(
//       state.search.chartresults
//     );

//     state.chart.customerSalesData = sortChartDataByValueAsc(
//       state.chart.customerSales
//     );
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

// // To load the Bill Chart
// export const loadCheckoutChartResults = async function (
//   query,
//   filterFromDate,
//   filterToDate,
//   branch
// ) {
//   try {
//     // To call the checkout API only for the first time and not when using filters, else it will take time to load
//     if (branch === undefined) {
//       await loadCheckoutSearchResults(query, filterFromDate, filterToDate);
//       branch = 'All';
//     }

//     // To filter the array based on user filter selection. Need to amend here if new filters are added
//     let filteredCheckoutData = state.checkout.results.filter(
//       item => branch === 'All' || item.branch === branch
//       // && (user === 'All' || item.user === user))
//     );

//     state.chart.monthlyBill = createMonthlyBillObject(filteredCheckoutData);
//     state.chart.sortedMonthlyBill = sortChartData(state.chart.monthlyBill);
//     state.chart.monthlyBillData = createChartDataArray(
//       state.chart.sortedMonthlyBill
//     );
//     // console.log(state.chart.monthlyBillData);
//   } catch (err) {
//     console.error(err);
//     throw err;
//   }
// };

// // Using array reduce method to sum up the price bought based on date (yyyy-mm only) bought. Object.create(null) is required to make the initial value of acc as an empty Object
// const createMonthlySalesObject = function (data) {
//   return data.reduce((acc, obj) => {
//     const key = obj.dateBought.substr(0, 7);
//     // const value = Number.parseFloat(obj.priceBought).toFixed(2);
//     acc[key] = (acc[key] || 0) + +obj.totalPaid;
//     return acc;
//   }, Object.create(null));
// };

// // Using array reduce method to sum up the price bought based on Customer Name. Object.create(null) is required to make the initial value of acc as an empty Object
// const createCustomerSalesObject = function (data) {
//   return data.reduce((acc, obj) => {
//     const key = obj.custName;
//     // const value = Number.parseFloat(obj.priceBought).toFixed(2);
//     acc[key] = (acc[key] || 0) + +obj.totalPaid;
//     return acc;
//   }, Object.create(null));
// };

// // Using array reduce method to sum up the price bought based on date (yyyy-mm only) bought. Object.create(null) is required to make the initial value of acc as an empty Object
// const createMonthlyBillObject = function (data) {
//   return data.reduce((acc, obj) => {
//     const key = obj.billDate.substr(0, 7);
//     // const value = Number.parseFloat(obj.priceBought).toFixed(2);
//     acc[key] = (acc[key] || 0) + +obj.billPaid;
//     return acc;
//   }, Object.create(null));
// };

// // To sort the data based on Object key which in this case is the Date. For Date sorting, only this method can work
// const sortChartData = function (data) {
//   return Object.keys(data)
//     .sort()
//     .reduce((obj, key) => {
//       obj[key] = data[key];
//       return obj;
//     }, {});
// };

// // Object.entries will convert the single Object into an Array containing groups of each object as an array, and to sort the data (ascending order) based on the 1st element in each array which is the Object keys
// const createChartDataArray = function (data) {
//   return Object.entries(data);
// };

// // Object.entries will convert the single Object into an Array containing groups of each object as an array, and to sort the data (ascending order) based on the 2nd element in each array which is the Object values
// const sortChartDataByValueAsc = function (data) {
//   return Object.entries(data).sort((x, y) => x[1] - y[1]);
// };
